import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OrdemServicoIn {
  ativoId: number;
  codigoEndereco: String = '';
  codigoTipoOS: String = '';
  observacao: String = '';
  ambientes: any;
  anexos: any;
 }
